import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import {
  KIND_OF_LEARNING_ANATOMY_OPTION_KEYS,
  KIND_OF_LEARNING_ANATOMY_QUESTION,
} from '~/pages/anatomy/kindOfLearning/libs/components/KindOfLearning/constants'
import { Styles as S } from '~/pages/anatomy/kindOfLearning/libs/components/KindOfLearning/styles'
import { Button } from '~/shared/components/Button'
import { OptionType } from '~/shared/constants/commonConstants'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { shuffleArray } from '~/shared/utils'

interface IKindOfLearningProps {
  nextPagePath: string
  pageId: string
}

const KindOfLearning = ({ nextPagePath, pageId }: IKindOfLearningProps) => {
  const { t } = useTranslation('anatomy')
  const [answers, setAnswers] = useState<string[]>([])
  const [shuffledKeys] = useState(() =>
    shuffleArray(KIND_OF_LEARNING_ANATOMY_OPTION_KEYS),
  )

  const handleOptionChange = (optionValue: string, isChecked: boolean) => {
    setAnswers((prev) =>
      isChecked
        ? [...prev, optionValue]
        : prev.filter((item) => item !== optionValue),
    )
  }

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: KIND_OF_LEARNING_ANATOMY_QUESTION,
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <S.ScrollContent>
          <S.Content>
            <S.Title>
              <Trans
                ns="anatomy"
                i18nKey="onboarding.kindOfLearningAnatomy.title"
              />
            </S.Title>
          </S.Content>

          {shuffledKeys.map((key) => {
            const optionText = t(
              `onboarding.kindOfLearningAnatomy.options.${key}`,
            )
            const spaceIndex = optionText.indexOf(' ')
            const emoji =
              spaceIndex !== -1 ? optionText.slice(0, spaceIndex) : optionText
            const text =
              spaceIndex !== -1 ? optionText.slice(spaceIndex + 1) : ''

            return (
              <S.StyledOption
                key={key}
                type={OptionType.CHECKBOX}
                value={key}
                name="kind-of-learning-anatomy"
                onChange={handleOptionChange}
                checked={answers.includes(key)}
              >
                <S.Value>
                  <S.OptionIcon>{emoji}</S.OptionIcon>
                  <S.ValueText>{text}</S.ValueText>
                </S.Value>
              </S.StyledOption>
            )
          })}
        </S.ScrollContent>

        <S.ButtonContainer>
          <Button
            type="button"
            onClick={() => handleContinue(answers)}
            disabled={!answers.length}
          >
            <Trans i18nKey="actions.continue" />
          </Button>
        </S.ButtonContainer>
      </S.StyledContainer>
    </S.Root>
  )
}

export default KindOfLearning
